import { Component, OnInit } from '@angular/core';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';


@Component({
  selector: 'app-newMetering',
  templateUrl: './newMetering.component.html',
})
export class NewMeteringComponent implements OnInit {

  constructor(
    private _authorizeService: AuthorizeService) {

  }

  ngOnInit() {

  }

}
